import React, { useEffect, useState } from "react";
import Moment from 'react-moment';
import moment from 'moment';
import 'moment/min/locales'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { red, green, yellow } from '@mui/material/colors';
import BarChartIcon from '@mui/icons-material/BarChart';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { useParams } from "react-router-dom";
import MySimpleMap from '../components/map/MySimpleMap';
import RadarIcon from '@mui/icons-material/Radar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import AddIcon from '@mui/icons-material/Add';
import Battery90Icon from '@mui/icons-material/Battery90';
import Battery80Icon from '@mui/icons-material/Battery80';
import Battery60Icon from '@mui/icons-material/Battery60';
import Battery50Icon from '@mui/icons-material/Battery50';
import Battery30Icon from '@mui/icons-material/Battery30';
import Battery20Icon from '@mui/icons-material/Battery20';
import BatteryAlertIcon from '@mui/icons-material/BatteryAlert';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import AuthService from "../services/auth.service";
import CopyButton from "../components/layout/CopyButton";
import MarkButton from "../components/layout/MarkButton";
import ReactTooltip from "react-tooltip";
import EditMap from "../components/map/EditMap";
import DetectorsByParkingTable from "./DetectorsByParkingTable";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
import AccessibleIcon from '@mui/icons-material/Accessible';
import Dropdown from 'react-multilevel-dropdown';
import RefreshIcon from '@mui/icons-material/Refresh';
import axios from "axios";
import authHeader from "../services/auth-header";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  root: {
    background: (props) =>
      props.color === 'red'
        ? 'linear-gradient(45deg, #FF0000 30%, #f26f8c 90%)'
        : 'linear-gradient(45deg, #008000 30%, #87eda2 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: (props) =>
      props.color === 'red'
        ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
        : '0 3px 5px 2px rgba(135, 237, 162, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
    margin: 8,
    textAlign: 'center'
  },
  detectorItem: {
    background: (props) =>
      props.color === 'red'
        ? 'linear-gradient(45deg, #FF0000 10%, #f26f8c 90%)'
        : 'linear-gradient(45deg, #008000 10%, #87eda2 90%)',
    border: 1,
    borderRadius: 30,
    boxShadow: (props) =>
      props.color === 'red'
        ? '0 3px 5px 2px rgba(255, 105, 135, .3)'
        : '0 3px 5px 2px rgba(135, 237, 162, .3)',
    color: 'white',
    textAlign: 'center'

  }
});
function renderIsBusyIcon(isBusyValue, typeOfDetector) {
  if(typeOfDetector === 0)
  {
    if (isBusyValue === 1) {
      return (<Avatar sx={{ background: 'linear-gradient(to right bottom, #F99B9B, #FF0000)', border: '4px solid lightgray' }}><TimeToLeaveIcon /></Avatar>)
    }
    else if (isBusyValue === 0) {
      return (<Avatar sx={{ background: 'linear-gradient(to right bottom, #66EC5B, #0C6804)',border: '4px solid lightgray' }}><TimeToLeaveIcon /></Avatar>)
    }
    else {
      return (<Avatar sx={{ bgcolor: yellow[500] }}><TimeToLeaveIcon /></Avatar>)
    }
  }
  else if(typeOfDetector === 1)
  {
    if (isBusyValue === 1) {
      return (<Avatar sx={{ background: 'linear-gradient(to right bottom, #F99B9B, #FF0000)', border: '4px solid #1D94E6' }}><AccessibleIcon /></Avatar>)
    }
    else if (isBusyValue === 0) {
      return (<Avatar sx={{ background: 'linear-gradient(to right bottom, #66EC5B, #0C6804)',border: '4px solid #1D94E6' }}><AccessibleIcon /></Avatar>)
    }
    else {
      return (<Avatar sx={{ bgcolor: yellow[500] }}><AccessibleIcon /></Avatar>)
    }
  }
  else if(typeOfDetector === 2)
  {
    if (isBusyValue === 1) {
      return (<Avatar sx={{ background: 'linear-gradient(to right bottom, #F99B9B, #FF0000)', border: '4px solid  #2BA70A' }}><ElectricCarIcon /></Avatar>)
    }
    else if (isBusyValue === 0) {
      return (<Avatar sx={{ background: 'linear-gradient(to right bottom, #66EC5B, #0C6804)',border: '4px solid  #2BA70A ' }}><ElectricCarIcon /></Avatar>)
    }
    else {
      return (<Avatar sx={{ bgcolor: yellow[500] }}><ElectricCarIcon /></Avatar>)
    }
  }
  else if(typeOfDetector === 3)
  {
    return (<Avatar sx={{ bgcolor: green[500] }}><DeleteIcon /></Avatar>)
  }
  else {
    if (isBusyValue === 1) {
      return (<Avatar sx={{ bgcolor: red[500] }}><TimeToLeaveIcon /></Avatar>)
    }
    else if (isBusyValue === 0) {
      return (<Avatar sx={{ bgcolor: green[500] }}><TimeToLeaveIcon /></Avatar>)
    }
    else {
      return (<Avatar sx={{ bgcolor: yellow[500] }}><TimeToLeaveIcon /></Avatar>)
    }
  }

}
function renderBattIcon(batteryValue) {
  var batteryPercentage = Math.round(100 * (batteryValue / 255));
  if (batteryPercentage >= 90) {
    return <Battery90Icon />
  }
  else if (batteryPercentage < 90 && batteryPercentage >= 80) {
    return <Battery80Icon />
  }
  else if (batteryPercentage < 80 && batteryPercentage >= 60) {
    return <Battery60Icon />
  }
  else if (batteryPercentage < 60 && batteryPercentage >= 50) {
    return <Battery50Icon />
  }
  else if (batteryPercentage < 50 && batteryPercentage >= 30) {
    return <Battery30Icon />
  }
  else if (batteryPercentage < 30 && batteryPercentage >= 20) {
    return <Battery20Icon />
  }
  else {
    return <BatteryAlertIcon />
  }
}

function Item1(props) {
  const { color, ...other } = props;
  const classes = useStyles(props);
  return <Paper variant="outlined" elevation={24} className={classes.detectorItem} {...other} />;
}
function MyButton(props) {
  const { color, ...other } = props;
  const classes = useStyles(props);
  return <Button className={classes.root} {...other} />;
}

MyButton.propTypes = {
  color: PropTypes.oneOf(['blue', 'red']).isRequired,
};
Item1.propTypes = {
  color: PropTypes.oneOf(['blue', 'red']).isRequired,
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',

}));

const api = require("../api/names.js");


function DetectorsByParking(props) {

  const { t } = useTranslation("common");
  moment.locale(t('detectorsbp.timelng'));
  function renderLastFrameTime(lastFrameTime) {
    if ((Math.round(moment().unix() - lastFrameTime / 1000)) > 86400) {
      // return <div>{moment.unix(lastFrameTime/1000).toNow(true)} (<Moment unix>{lastFrameTime/1000}</Moment>) - !!!Warning (>24h)!!! </div>;
      return <div>{t('detectorsbp.laststatus')}{moment.unix(lastFrameTime / 1000).toNow(true)} - {t('detectorsbp.wartimestamp')}
      </div>;

    }
    else {
      //return <div>{moment.unix(lastFrameTime/1000).toNow(true)} (<Moment unix>{lastFrameTime/1000}</Moment>)</div>;
      return <div>{t('detectorsbp.laststatus')}{moment.unix(lastFrameTime / 1000).toNow(true)}  </div>;

    }
  }

  function renderFreeOrOcuupiedTime(detectorData) {
    if (detectorData.detectorsCurrentValue.isBusy) {
      //return <div className="rowitem">Zajęty: {Math.round(moment().unix() - params.row.detectorsCurrentValue.entryTimestamp/1000)} s</div>;
      return <div>{t('detectorsbp.busy.1') + ': '}{moment.unix(detectorData.detectorsCurrentValue.entryTimestamp / 1000).toNow(true)}</div>;
    }
    else {
      //return <div className="rowitem">Wolny: {Math.round(moment().unix() - params.row.detectorsCurrentValue.exitTimestamp/1000)} s</div>;
      return <div>{t('detectorsbp.free.1')}{moment.unix(detectorData.detectorsCurrentValue.exitTimestamp / 1000).toNow(true)}</div>;
      //moment([2007, 0, 29]).fromNow();
    }
  }
  const [currentUser, setCurrentUser] = useState(undefined);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoaded2, setIsLoaded2] = useState(false);
  const [items, setItems] = useState([]);
  const [itemsLedTables, setItemsLedTables] = useState([]);
  const [itemsBusy, setItemsBusy] = useState([]);
  const [itemsWithWarningTime, setItemsWithWarningTime] = useState([]);
  const [itemsWithWarningBattery, setItemsWithWarningBattery] = useState([]);
  const [itemsNotBusy, setItemsNotBusy] = useState([]);
  const [Table,setTable] = useState(false);
  const [parkings, setParkings] = useState(false);
  const [parking, setParking] = useState(null);

  const [siteNumber, setSiteNumber] = useState(1);
  const [numberOfSites, setNumberOfSites] = useState(1);
  const [siteData, setSiteData] = useState([]);

  const [Search, setSearch] = useState(false);
  const [Sort, setSort] = useState(false);
  const [sortData, setSortData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [numberOfRecords, setNumberOfRecords] = useState(1);
  const [searchRecords, setSearchRecords] = useState([]);
  const [phrase, setPhrase] = useState("");
  const [sortTemp, setSortTemp] = useState(1);

  const [markDetectors, setMarkDetectors] = useState([]);

  const params = useParams();

  //console.log(params);
  useEffect(() => {
    const user = AuthService.getCurrentUser();
    var url;

    if (user) {
      setCurrentUser(user);
    }

    setParking(params.parkingID);

    if (user.id === 4) {
      url = api.baseUrl + '/parkings/';
    }
    else {
      url = api.baseUrl + '/parkings/byUserID/';
      url += user.id;
    }

    fetch(url, {
      method: 'get',
      headers: authHeader()
    })
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
          setParkings(result);
          setIsLoaded(true);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )

    loadCurrentDataFromApi(params.parkingID);
    loadCurrentLedTableDataFromApi(params.parkingID);

    const interval = setInterval(() => {
      loadCurrentDataFromApi(params.parkingID);
      loadCurrentLedTableDataFromApi(params.parkingID);
    }, 5000);

    return () => clearInterval(interval);
  }, [params.parkingID])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      search();
    }
  }

  function setCopyButton(eui)
  {
    return(
    <div key={eui}  >
      {t('detectorsbp.eui') + ': ' + eui + ' '}
      <CopyButton txt={eui}/>
      <ReactTooltip id="copyTip" place="top" effect="solid" type="light" >
        {t('detectorsbp.copy')}
      </ReactTooltip>
    </div>)
  }

  function setView()
  {
    setTable(!Table);
    setSearch(false);
  }

  const phraseHandler = (e) =>{
    var lowerCase = e.target.value.toLowerCase();
    setPhrase(lowerCase);
  }

  function search()
  {
    var data = ([]);
    for (var i = 0; i < numberOfRecords; i++)
    {
      if (searchRecords[i].includes(phrase))
      {
        data.push(items[i]);
      }
    }
    setSearchData(Array.from(data).slice(0,10));
    setSearch(true);
  }

  function sort(nr)
  {
    var sort = items;
    switch(nr)
    {
      case 1: sort = sort.sort((a, b) => (a.address > b.address) ? 1 : -1); break;
      case 2: sort = sort.sort((a, b) => (a.address > b.address) ? -1 : 1); break;
      case 3: sort = sort.sort((a, b) => (a.positionOnParking > b.positionOnParking) ? 1 : -1); break;
      case 4: sort = sort.sort((a, b) => (a.positionOnParking > b.positionOnParking) ? -1 : 1); break;
      case 5: sort = sort.sort((a, b) => (a.detectorsCurrentValue.timestamp > b.detectorsCurrentValue.timestamp) ? -1 : 1); break;
      case 6: sort = sort.sort((a, b) => (a.detectorsCurrentValue.timestamp > b.detectorsCurrentValue.timestamp) ? 1 : -1); break;
      case 7: sort = sort.sort((a, b) => (a.type > b.type) ? -1 : 1); break;
      default: sort = sort.sort((a, b) => (a.address > b.address) ? 1 : -1);
    }
    var data = ([]);
    for (var i = 0; i < numberOfSites; i++) {
      data[i] = Array.from(sort).slice(i * 10, (i + 1) * 10);
    }
    setSortData(data);
    setSortTemp(nr);
    setSort(true);
  }

  function changesite(number)
  {
    setSearch(false);
    if(numberOfSites<=number)
        setSiteNumber(numberOfSites);
      else if(number<=1)
        setSiteNumber(1);
      else
        setSiteNumber(number);
  }

  function accData()
  {
    if(Search)
    {
      return searchData;
    }
    else if(Sort)
    {
      return sortData[siteNumber-1];
    }
    else
    {
      return siteData[siteNumber-1];
    }
  }

  const parkingHandler = (e) => {
    var txt = e.target.value;
    setParking(txt);
  }

  function saveParking(address)
  {
    var url = api.baseUrl + '/detectorsEUIs/';
    url += address;
    const jsonData = {
      "parkingID":parking
    }
    axios.put(url, jsonData, { headers: authHeader() });
    window.location.reload(false);
  }

  function changeMarkDetectors(address)
  {
    let temp = markDetectors;
    let idx = markDetectors.indexOf(address);
    if(idx === -1)
      temp.push(address);
    else
      temp.splice(idx,1);
    console.log(temp);
    setMarkDetectors(temp);
  }

  function getMark(address)
  {
    if(markDetectors.includes(address))
      return 1;
    else
      return 0;
  }

  function setMarkButton(address)
  {
    return(
      <div key={address} >
      {t('detectorsbp.id') + ': ' + address + ' '}
      <MarkButton mark={getMark(address)} onMouseClick={() => { changeMarkDetectors(address)}}/>
      {/*<Button data-tip data-for="markTip"
        style={{ maxWidth: "20px", maxHeight: "20px", minWidth: "15px", marginRight: "0px", marginLeft: "0px", padding: "0px,0px" }}
        onClick={(e) => { e.stopPropagation(); changeMarkDetectors(address); }}
        >{getMark(address) ? (<LocationOnIcon color="secondary" fontSize="small" />) :
      (<NotListedLocationIcon color="action" fontSize="small" />)}
    </Button>*/}
      <ReactTooltip id="markTip" place="top" effect="solid" type="light" >
        {t('detectorsbp.mark')}
      </ReactTooltip>
      </div>
    );
  }

  function loadCurrentDataFromApi(parkingId) {
    var url = api.baseUrl + '/detectorsEUIs/WithMetadataByParkingID/';
    url += parkingId;//props.parkingID;
    //console.log(url);
    fetch(url, {
  method: 'get',
  headers: authHeader()
  })
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);

          setItems(result);
          setItemsBusy(result.filter(item => item.detectorsCurrentValue.isBusy === 1));
          setItemsNotBusy(result.filter(item => item.detectorsCurrentValue.isBusy === 0));
          setItemsWithWarningTime(result.filter(item => (item.detectorsCurrentValue.timestamp / 1000) < (Math.round(moment().unix()) - 86400)));
          setItemsWithWarningBattery(result.filter(item => (item.detectorsCurrentValue.battery< 100)));
          const length = Math.ceil(result.length / 10);
          setNumberOfSites(length);
          var data = ([]);
          for (var i=0; i<length; i++)
          {
            data[i] = Array.from(result).slice(i*10, (i+1)*10)
          }
          setSiteData(data);

          setNumberOfRecords(result.length);
          data = ([]);
          for ( i= 0; i<result.length; i++)
          {
            data[i] = "i"+result[i].address.toString()+"e"+result[i].eui.toString()+"p"+result[i].positionOnParking.toString()+"t"+result[i].type;
          }
          setSearchRecords(data);
          setIsLoaded2(true);
        },
        (error) => {
          setIsLoaded2(true);
          setError(error);
        }
      );
  }
  function loadCurrentLedTableDataFromApi(parkingId) {
    var url = api.baseUrl + '/ledTables/byParkingID/';
    url += parkingId;//props.parkingID;
    //console.log(url);
    fetch(url, {
  method: 'get',
  headers: authHeader()
  })
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);

          setItemsLedTables(result);

            },
        (error) => {
          setError(error);
        }
      );
  }


  //setNumberOfSites(Math.ceil(items.length / 10));
  //changesite(1);

  const columnsLed = [


    {
      field: 'desription',
      headerName: 'Tablica',
      width: 100,
    },

    {
      field: 'street',
      headerName: 'Opis',
      width: 300,
    },

    {
      field: 'valueAdr0',
      headerName: 'Wolne miejsca',
      width: 150,
    },

    {
      field: 'valueAdr1',
      headerName: 'Wolne miejsca niepełnosprawne',
      width: 300,
    }





  ];
  const columns = [


    {
      field: 'isBusy',
      headerName: t('detectorsbp.busy.1'),
      width: 100,
      renderCell: (params) => {
        return params.row.detectorsCurrentValue.isBusy
      },
      valueGetter: (params) => params.row.detectorsCurrentValue.isBusy,
    },

    {
      field: 'address',
      headerName: t('detectorsbp.id'),
      width: 90,
    },
    {
      field: 'eui',
      headerName: t('detectorsbp.eui'),
      width: 180
    },

    {
      field: 'battery',
      headerName: t('detectorsbp.battery'),
      width: 200,
      renderCell: (params) => {
        if (params.row.detectorsCurrentValue.battery < 100) {
          return <div className="rowitem">{params.row.detectorsCurrentValue.battery}{t('detectorsbp.warbattery.2')}</div>;
        }
        else {
          return <div className="rowitem">{params.row.detectorsCurrentValue.battery}</div>;
        }

      },
      valueGetter: (params) => params.row.detectorsCurrentValue.battery,

    },

    {
      field: 'timestamp',
      headerName: t('detectorsbp.timestamp'),
      width: 500,
      renderCell: (params) => {
        if ((Math.round(moment().unix() - params.row.detectorsCurrentValue.timestamp / 1000)) > 86400) {
          return <div className="rowitem">{moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).toNow(true)} (<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{params.row.detectorsCurrentValue.timestamp / 1000}</Moment>) - !!!{t('detectorsbp.wartimestamp')}</div>;

        }
        else {
          return <div className="rowitem">{moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).toNow(true)} (<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{params.row.detectorsCurrentValue.timestamp / 1000}</Moment>)</div>;

        }
      },
      valueGetter: (params) => moment.unix(params.row.detectorsCurrentValue.timestamp / 1000).format("HH:mm:ss - DD/MM/YYYY"),

    },





  ];



  //const data = Array.from(items).slice(0,10);

  if (error) {
    return <div>{t('detectord.error')}{error.message}</div>;
  } else if (!isLoaded) {
    return <div>{t('detectord.loading')}</div>;
  } else if (!isLoaded2) {
    return <div>{t('detectord.loading')}</div>;
  } else {
    return (
      <div>
        {/*    <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
               <TableRow>
               <TableCell>All detectors</TableCell>
                <TableCell>Free detectors</TableCell>
                <TableCell >Occupied detectors</TableCell>
                <TableCell >% Free detectors</TableCell>
                <TableCell >% Occupied detectors</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

                <TableRow

                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                 <TableCell >{items.length}</TableCell>
                  <TableCell >{itemsNotBusy.length}</TableCell>
                  <TableCell >{itemsBusy.length}</TableCell>
                  <TableCell >{Math.round((itemsNotBusy.length/items.length)*100)}%</TableCell>
                  <TableCell >{Math.round((itemsBusy.length/items.length)*100)}%</TableCell>
                </TableRow>

            </TableBody>
          </Table>
        </TableContainer>
    */}

        <Container maxWidth="xl">
        {(currentUser.id === 4 || currentUser.id === 19) && <div style={{ height: 300, width: '100%' }}>

          <DataGrid

            rows={itemsLedTables}
            columns={columnsLed}
            pageSize={100}
            rowsPerPageOptions={[10]}
            checkboxSelection
            disableSelectionOnClick
            getRowId={(row) => row.address}
            localeText={{
              toolbarColumns: t('gridtoolbar.columns'),
              toolbarFilters: t('gridtoolbar.filters'),
              toolbarDensity: t('gridtoolbar.density'),
              toolbarExport: t('gridtoolbar.export')
            }}
            components={{
              Toolbar: GridToolbar,
            }}
          />
        </div> }
          <Box sx={{ width: '100%' }}>



            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

              <Grid item xs={12} lg>
                <Item>{t('detectorsbp.allsensors')}{items.length}</Item>
              </Grid>
              <Grid item xs={12} sm={6} lg>
                <Item>{itemsNotBusy.length}{t('detectorsbp.free.2')}</Item>
              </Grid>
              <Grid item xs={12} sm={6} lg>
                <Item>{itemsBusy.length}{t('detectorsbp.busy.2')}</Item>
              </Grid>
              <Grid item xs={12} sm={6} lg>
                <Item>{Math.round((itemsNotBusy.length / items.length) * 100)}%{t('detectorsbp.free.2')}</Item>
              </Grid>
              <Grid item xs={12} sm={6} lg>
                <Item>{Math.round((itemsBusy.length / items.length) * 100)}%{t('detectorsbp.busy.2')}</Item>
              </Grid>

            </Grid>
          </Box>
          <MySimpleMap gpsLatitude={props.gpsLatitude} gpsLongtitude={props.gpsLongtitude} parkingID={params.parkingID} markDetectors={markDetectors} />
          <br />
          <Button variant="outlined" onClick={() => setView()}>
            {Table ? t('detectorsbp.tableview') : t('detectorsbp.blockview')}
          </Button>
          <br />
          <br />
          {!Table && (
          <Box sx={{ flexGrow: 1 }} >
            <Button onClick={() => changesite(siteNumber - 5)}>
              <KeyboardDoubleArrowLeftIcon />
            </Button>
          <Button onClick={() => changesite(siteNumber - 1)}>
            <KeyboardArrowLeftIcon/>
          </Button>
          {siteNumber}/{numberOfSites}
          <Button onClick={() => changesite(siteNumber + 1)}>
              <KeyboardArrowRightIcon />
          </Button>
          <Button onClick={() => changesite(siteNumber + 5)}>
            <KeyboardDoubleArrowRightIcon />
          </Button>
          <TextField size="small" id="search" onKeyDown={handleKeyDown} onChange={phraseHandler} label="···" type="search"/>
          <Button onClick={() => search()}>
            {t('detectorsbp.search')}
          </Button>
          <Dropdown title={t('detectorsbp.sort')}>
            <Dropdown.Item >
            {t('detectorsbp.sortby')}{t('detectorsbp.id')}
              <Dropdown.Submenu >
                <Dropdown.Item onClick={() => sort(1)}>
                  {t('detectorsbp.ascending')}
                </Dropdown.Item>
                <Dropdown.Item onClick={() => sort(2)}>
                  {t('detectorsbp.descending')}
                </Dropdown.Item>
              </Dropdown.Submenu>
            </Dropdown.Item>
            <Dropdown.Item >
              {t('detectorsbp.sortby')}{t('detectorsbp.parkingplace')}
              <Dropdown.Submenu >
                <Dropdown.Item onClick={() => sort(3)}>
                  {t('detectorsbp.ascending')}
                </Dropdown.Item>
                <Dropdown.Item onClick={() => sort(4)}>
                  {t('detectorsbp.descending')}
                </Dropdown.Item>
              </Dropdown.Submenu>
            </Dropdown.Item>
            <Dropdown.Item >
              {t('detectorsbp.sortby')}{t('detectorsbp.sortlaststatus')}
              <Dropdown.Submenu >
                <Dropdown.Item onClick={() => sort(5)}>
                  {t('detectorsbp.ascending')}
                </Dropdown.Item>
                <Dropdown.Item onClick={() => sort(6)}>
                  {t('detectorsbp.descending')}
                </Dropdown.Item>
              </Dropdown.Submenu>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => sort(7)}>
              {t('detectorsbp.sortby')}{t('detectorsbp.type')}
            </Dropdown.Item>
          </Dropdown>
          <Button onClick={() => sort(sortTemp)}>
            <RefreshIcon/>
          </Button>
          </Box>)}
          <Box sx={{ flexGrow: 1 }} >
            {!Table ? (
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
              {Array.from(accData()).map((_, index) => (
                <Grid item sm={6} md={6} key={index}>
                  <Item elevation={24}>

                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                      <Grid item md={12}>
                        <Accordion>
                          <AccordionSummary

                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                          >
                            <Grid item xs={12}>
                              <Item elevation={24}>

                                <ListItem>
                                  <ListItemAvatar>

                                    {renderIsBusyIcon(_.detectorsCurrentValue.isBusy, _.type)}
                                    P: {_.positionOnParking}
                                  </ListItemAvatar>
                                  <Grid item sm={12}>
                                    <ListItemText
                                    //primary={t('detectorsbp.id') + ': ' + _.address {< NotListedLocationIcon />}}
                                      primary={setMarkButton(_.address)}
                                      secondary={setCopyButton(_.eui) }
                                    />
                                    <ListItemText
                                      primary={renderFreeOrOcuupiedTime(_)}
                                      secondary={renderLastFrameTime(_.detectorsCurrentValue.timestamp)}
                                    />
                                  </Grid>


                                </ListItem>


                              </Item>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid item sm={12}>
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <BarChartIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={<Button href={'/detectorDetails/' + params.parkingID + '/' + _.address} variant="outlined" startIcon={<BarChartIcon />}>{t('detectorsbp.his')}</Button>}
                                />
                              </ListItem>
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <RadarIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="Radar"
                                  secondary={_.detectorsCurrentValue.radar}
                                />
                              </ListItem>)}
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <ArrowForwardIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="X"
                                  secondary={_.detectorsCurrentValue.x}
                                />
                              </ListItem>)}
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <ArrowUpwardIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="Y"
                                  secondary={_.detectorsCurrentValue.y}
                                />
                              </ListItem>)}
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    {
                                      renderBattIcon(_.detectorsCurrentValue.battery)
                                    }
                                  </Avatar>
                                </ListItemAvatar>

                                {(_.detectorsCurrentValue.battery >= 100) && (<ListItemText
                                  primary={t('detectorsbp.battery')}
                                  secondary={_.detectorsCurrentValue.battery}
                                />)}
                                {(_.detectorsCurrentValue.battery < 100) && (<ListItemText
                                  primary={t('detectorsbp.warbattery.2')}
                                  secondary={_.detectorsCurrentValue.battery}
                                />)}
                              </ListItem>
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <ThermostatIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={t('detectord.temperature')}
                                  secondary={_.detectorsCurrentValue.temperature}
                                />
                              </ListItem>)}
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <AccessTimeIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={t('detectorsbp.timestamp')}
                                  secondary={renderLastFrameTime(_.detectorsCurrentValue.timestamp)}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={t('detectorsbp.lastchange')}
                                  secondary={renderFreeOrOcuupiedTime(_)}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={t('detectorsbp.entry')}
                                  secondary={<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{_.detectorsCurrentValue.entryTimestamp / 1000}</Moment>}
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={t('detectorsbp.leave')}
                                  secondary={<Moment format="HH:mm:ss - DD/MM/YYYY" unix>{_.detectorsCurrentValue.exitTimestamp / 1000}</Moment>}
                                />
                              </ListItem>
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={t('detectord.counter')}
                                  secondary={_.detectorsMetadatum.counter}
                                />
                              </ListItem>)}
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={t('detectord.frame')}
                                  secondary={_.detectorsCurrentValue.frameType}
                                />
                              </ListItem>)}
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="SF"
                                  secondary={_.detectorsMetadatum.dataRate}
                                />
                              </ListItem>)}
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="RSSI"
                                  secondary={_.detectorsMetadatum.rssi}
                                />
                              </ListItem>)}
                              {currentUser.id === 4 && (<ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="SNR"
                                  secondary={_.detectorsMetadatum.snr}
                                />
                              </ListItem>)}
                              <ListItem>
                                <ListItemAvatar>
                                  <Avatar>
                                    <TimeToLeaveIcon />
                                  </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary="Zmień parking"
                                  secondary={
                                  <div key={_.address}>
                                    <TextField size="large" select value={parking} onChange={parkingHandler} label="Parking ID" InputLabelProps={{ shrink: true, }} style={{ m: 1, width: '10ch' }}>
                                      {parkings.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                          {option.id}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                    <Button onClick = {() => saveParking(_.address)} variant="outlined" startIcon={<AddIcon />} >
                                    </Button>
                                  </div>}
                                />
                              </ListItem>


                            </Grid>
                          </AccordionDetails>
                        </Accordion>

                      </Grid>

                    </Grid>
                  </Item>



                </Grid>
              ))}
            </Grid>
            ) :

              (<DetectorsByParkingTable />)

            }
          </Box>

        </Container>

        <br />

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>{t('detectorsbp.warnings')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ height: 450, width: '100%' }}>
              {t('parkingerrors.longago')}
              <DataGrid

                rows={itemsWithWarningTime}
                columns={columns}
                pageSize={100}
                rowsPerPageOptions={[10]}
                checkboxSelection
                disableSelectionOnClick
                getRowId={(row) => row.address}
                localeText={{
                  toolbarColumns: t('gridtoolbar.columns'),
                  toolbarFilters: t('gridtoolbar.filters'),
                  toolbarDensity: t('gridtoolbar.density'),
                  toolbarExport: t('gridtoolbar.export')
                }}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </div>
            <br />
            <br />
            <div style={{ height: 450, width: '100%' }}>
              {t('parkingerrors.batterylow')}
              <DataGrid

                rows={itemsWithWarningBattery}
                columns={columns}
                pageSize={100}
                rowsPerPageOptions={[10]}
                checkboxSelection
                disableSelectionOnClick
                getRowId={(row) => row.address}
                localeText={{
                  toolbarColumns: t('gridtoolbar.columns'),
                  toolbarFilters: t('gridtoolbar.filters'),
                  toolbarDensity: t('gridtoolbar.density'),
                  toolbarExport: t('gridtoolbar.export')
                }}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </div>
          </AccordionDetails>
        </Accordion>

        {currentUser.id === 4 && (<Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>Ustawienia Mapki</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ height: 350, width: '100%' }}>
              <EditMap gpsLatitude={props.gpsLatitude} gpsLongtitude={props.gpsLongtitude} parkingID={params.parkingID} />

            </div>
          </AccordionDetails>
        </Accordion>)}














      </div>
    );
  }
}

export default DetectorsByParking;
